import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import ArtistCard from "../components/ArtistCard";
import TrackCard from "../components/TrackCard";
import { Sparkles } from "lucide-react";

export const FeaturedPage = () => {
  const [artists, setArtists] = useState([]);
  const [tracks, setTracks] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/artists", { params: { featured: true, limit: 20 } }),
      api.get("/tracks", { params: { featured: true, limit: 20 } }),
    ]).then(([a, t]) => { setArtists(a.data); setTracks(t.data); }).catch(() => {});
  }, []);

  return (
    <div className="px-6 md:px-12 py-10 max-w-7xl mx-auto" data-testid="featured-page">
      <p className="text-[10px] tracking-[0.25em] uppercase text-brand-yellow font-bold mb-2 inline-flex items-center gap-2">
        <Sparkles size={12} /> Mise en lumière
      </p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter mb-10">
        Artistes en vedette
      </h1>

      {artists.length === 0 ? (
        <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-10 text-center mb-10">
          <p className="text-white/70">L'administrateur sélectionnera bientôt les artistes en vedette.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16" data-testid="featured-grid">
          {artists[0] && <ArtistCard artist={artists[0]} variant="hero" />}
          {artists.slice(1, 5).map((a) => (
            <div key={a.user_id} className="rounded-xl border border-white/10 bg-white/[0.02] p-4 hover:bg-white/[0.05] transition-colors">
              <ArtistCard artist={a} />
            </div>
          ))}
        </div>
      )}

      <h2 className="font-display text-2xl md:text-3xl font-black mb-6">Morceaux en vedette</h2>
      {tracks.length === 0 ? (
        <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-10 text-center">
          <p className="text-white/70">Pas encore de morceau mis en vedette.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {tracks.map((t) => <TrackCard key={t.track_id} track={t} list={tracks} />)}
        </div>
      )}
    </div>
  );
};

export default FeaturedPage;
